import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';
import { AvailableFilterOptionDto } from './available-filter-option-dto.type';

const AvailableSearchOptionDto = t.type(
  {
    entityType: nullable(t.string),
    name: t.string,
    order: nullable(t.number),
    filters: nullable(t.array(AvailableFilterOptionDto)),
    disabledGlobalFilters: nullable(t.array(t.string)),
  },
  'AvailableSearchOptionDto',
);

type AvailableSearchOptionDto = t.TypeOf<typeof AvailableSearchOptionDto>;
export { AvailableSearchOptionDto };
